import { render, staticRenderFns } from "./TriggerCountTableWidget.vue?vue&type=template&id=72fc6da2&scoped=true"
import script from "./TriggerCountTableWidget.vue?vue&type=script&lang=js"
export * from "./TriggerCountTableWidget.vue?vue&type=script&lang=js"
import style0 from "./TriggerCountTableWidget.vue?vue&type=style&index=0&id=72fc6da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc6da2",
  null
  
)

export default component.exports